// extracted by mini-css-extract-plugin
module.exports = {"Root":"Button_Root__FBWj2"};